var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _vm.loading
        ? _c("profile-container-loader")
        : _c(
            "fragment",
            [
              _c("profile-picture", {
                attrs: { "user-details": _vm.userDetails },
                on: {
                  "submit-upload": _vm.handleUploadProfilePhoto,
                  "submit-remove": _vm.handleRemoveProfilePhoto,
                },
              }),
              _vm._v(" "),
              _c("change-password", {
                ref: "changePasswordForm",
                on: {
                  submit: _vm.handlePasswordSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
              _vm._v(" "),
              _c("change-brokerage", {
                ref: "changeBrokerageForm",
                attrs: {
                  "account-details": _vm.accountDetails,
                  permissions: _vm.permissions,
                },
                on: {
                  submit: _vm.handleBrokerageSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
              _vm._v(" "),
              _c("language-preferences", {
                ref: "languagePreferencesForm",
                attrs: { "account-details": _vm.accountDetails },
                on: {
                  submit: _vm.handleLanguagePreferencesSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
              _vm._v(" "),
              _c("account-preferences", {
                ref: "accountPreferencesForm",
                attrs: { "account-preferences": _vm.accountPreferences },
                on: {
                  submit: _vm.handleAccountPreferencesSubmit,
                  "initial-submit": _vm.handleSubmit,
                  "allow-save": _vm.handleAllowSave,
                  "form-change": _vm.handleFormChange,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }